// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal___2R8EP","btn":"btn___1qcx8"};